<template>
  <div>
    <!-- header with save and cancel buttons -->
    <div style="display: flex; justify-content: space-between; align-items: center">
      <v-btn fab depressed color="primary" small :to="`/regalos/campaign/${campaign_id}`"
        ><v-icon>mdi-close</v-icon></v-btn
      >

      <v-btn fab depressed color="success" small @click="save"><v-icon>mdi-check</v-icon></v-btn>
    </div>
    <h1>Editar campaña</h1>
    <div v-if="campaign">
      <div v-if="loading">...</div>
      <div v-else>
        <v-text-field v-model="campaign.title" label="título" outlined></v-text-field>
        <v-text-field v-model="campaign.description" label="descripción" outlined></v-text-field>
        <v-text-field v-model="campaign.budget" type="number" label="presupuesto" outlined></v-text-field>

        <!-- group -->
        <div>
          <h2>Grupo</h2>
          <p>Selecciona el grupo al que pertenece esta campaña</p>
          <ChipDropdown :items="groupsList" v-model="campaign.group" label="Grupo" />
        </div>

        <!-- owners (contributors)-->
        <div style="margin-bottom: 10px">
          <h2>Colaboradores</h2>
          <p>Selecciona qué usuarios tienen acceso a esta campaña</p>
          <v-chip-group column v-model="campaign.owners" multiple>
            <v-chip
              v-for="friend in friendsList"
              :key="friend.username"
              :value="friend.username"
              filter
              :disabled="friend.username == username"
              >{{ friend.name }}</v-chip
            >
          </v-chip-group>

          <!-- ajustar cuentas -->
          <div>
            <v-checkbox v-model="campaign.split_spend" label="Repartir gastos"></v-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
import { friends, groups } from './regalos-data'
import { mapGetters } from 'vuex'
import ChipDropdown from '@/components/ChipDropdown.vue'
export default {
  components: {
    ChipDropdown,
  },
  props: {
    campaign_id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      campaign: {},
    }
  },
  computed: {
    ...mapGetters(['username']),
    friendsList() {
      return friends([this.campaign], this.username)
    },
    groupsList() {
      return groups(this.username)
    },
  },

  methods: {
    async save() {
      //TODO
      this.loading = true
      let x = await api.apiFetch(`/regalos/campaign`, {
        method: 'POST',
        body: JSON.stringify(this.campaign),
      })
      this.loading = false
      if (!x.ok) alert('Something failed')
      const j = await x.json()
      this.campaign = j
      this.$router.push('/regalos')
    },
    async fetchData() {
      //TODO
      this.loading = true
      let x = await api.apiFetch(`/regalos/campaign?id=${this.campaign_id}`)
      this.loading = false
      if (!x.ok) alert('Something went wrong')

      const j = await x.json()
      if (!j.owners) j.owners = [] //TODO: ahouldnt be empty, doing this to avoid issues
      this.campaign = j
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
